<div class="modal-responsive-wrapper bg-white" style="border-radius: 12px; overflow: hidden; max-width: 100vw;">
  
  <!-- Cabecera Flexible -->
  <div class="bg-white p-3 text-dark d-flex justify-content-between align-items-center border-bottom border-light-subtle">
    <h5 class="mb-0 fw-bold font-monospace" style="font-size: calc(0.9rem + 0.3vw); color: #1e293b;">
      🛠️ Gestión Operativa - OS #{{ data.id }}
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="cerrarModal()"></button>
  </div>

  <form [formGroup]="orderForm" (ngSubmit)="guardarCambiosOS()" class="p-3 p-md-4">
    
    <!-- 🚀 CONTENEDOR ELÁSTICO RESPONSIVO: Pasa de 2 columnas en PC a 1 columna en Celular automáticamente -->
    <div class="row g-3 row-cols-1 row-cols-md-2">
      
      <!-- Sección 1: Datos Técnicos y Asignación de Mecánico -->
      <div class="col border-end-md pe-md-4">
        <h6 class="text-secondary font-monospace fw-bold mb-2 small text-uppercase">📋 Resumen del Expediente</h6>
        
        <div class="mb-3">
          <label class="form-label font-monospace fw-bold text-muted" style="font-size: 0.75rem;">IMPORTE AUTORIZADO DE TRABAJO</label>
          <div class="input-group">
            <span class="input-group-text bg-light fw-bold text-primary">$</span>
            <input type="text" class="form-control form-control-lg bg-light text-primary fw-bold font-monospace text-end" style="font-size: 1.25rem;" formControlName="orderAmount">
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label font-monospace fw-bold text-secondary small text-uppercase">Mecánico Asignado a Rampa</label>
          <!-- Select ampliado para fácil interacción táctil en tablets de patio -->
          <select class="form-select py-2 shadow-sm text-uppercase small" formControlName="an8Tecnico"
                  [ngClass]="{'is-invalid': orderForm.get('an8Tecnico')?.touched && orderForm.get('an8Tecnico')?.invalid}">
            <option [value]="null" disabled selected>{{ cargandoMecanicos ? '⏳ CONSULTANDO DISPONIBILIDAD EN PATIO...' : '-- ASIGNAR EMPLEADO --' }}</option>
            <option *ngFor="let m of listaMecanicos" [value]="m.an8"> 
              MEC-{{ m.an8 }} : {{ m.username || m.nombre }}  
            </option>
             <!-- MEC-{{ m.an8 }} : {{ m.nameAlpha || m.nombre }} -->
          </select>
          <div class="invalid-feedback fw-bold small">Se requiere asignar un mecánico para liberar la orden.</div>
        </div>
      </div>

      <!-- Sección 2: Tablero Kanban de Control de Tiempos -->
      <div class="col ps-md-4 bg-light-subtle rounded p-2 p-md-3 border-start-md mt-3 mt-md-0">
        <h6 class="text-secondary font-monospace fw-bold mb-2 small text-uppercase">⏱️ Reloj de Control de Rampa</h6>
        
        <div class="alert text-center fw-bold font-monospace shadow-sm mb-3 py-2"
              [ngClass]="{
                'bg-secondary-subtle text-secondary-emphasis border-secondary-subtle': orderForm.get('orderStatus')?.value === 'EN_PROGRESO',
                'bg-warning-subtle text-warning-emphasis border-warning-subtle': orderForm.get('orderStatus')?.value === 'EN_RAMPA',
                'bg-info-subtle text-info-emphasis border-info-subtle': orderForm.get('orderStatus')?.value === 'PINTURA',
                'bg-success-subtle text-success-emphasis border-success-subtle': orderForm.get('orderStatus')?.value === 'TERMINADO'
              }" style="font-size: 1rem; border-radius: 6px;">
          🚀 FASE ACTUAL: {{ orderForm.get('orderStatus')?.value || 'PEND_ASIG' }}
        </div>

        <!-- Botones de Conmutación Táctiles Hidratados de Estilos Móviles (Sincronizados con orderStatus) -->
        <div class="d-flex flex-column gap-2">
          
          <!-- 🚀 CORREGIDO: El primer hito físico real es EN_PROGRESO (Técnico Asignado / Fila de Espera) -->
          <button type="button" class="btn btn-sm btn-outline-secondary text-start text-dark fw-bold p-2.5 d-flex justify-content-between align-items-center" 
                  [class.active]="orderForm.get('orderStatus')?.value === 'EN_PROGRESO'" (click)="cambiarEstatusRampa('EN_PROGRESO')">
            <span>📦 1. Asignado / En Bahía de Espera</span>
            <span class="badge bg-secondary text-white font-monospace" style="font-size: 0.65rem;">EN PROGRESO</span>
          </button>
          
          <button type="button" class="btn btn-sm btn-outline-warning text-start text-dark fw-bold p-2.5 d-flex justify-content-between align-items-center" 
                  [class.active]="orderForm.get('orderStatus')?.value === 'EN_RAMPA'" (click)="cambiarEstatusRampa('EN_RAMPA')">
            <span>🔧 2. Mecánica Activa / Elevador</span>
            <span class="badge bg-warning text-dark font-monospace" style="font-size: 0.65rem;">EN RAMPA</span>
          </button>
          
          <button type="button" class="btn btn-sm btn-outline-info text-start text-dark fw-bold p-2.5 d-flex justify-content-between align-items-center" 
                  [class.active]="orderForm.get('orderStatus')?.value === 'PINTURA'" (click)="cambiarEstatusRampa('PINTURA')">
            <span>🎨 3. Cabina de Pintura / Estética</span>
            <span class="badge bg-info text-dark font-monospace" style="font-size: 0.65rem;">PINTURA</span>
          </button>
          
          <button type="button" class="btn btn-sm btn-outline-success text-start fw-bold p-2.5 d-flex justify-content-between align-items-center" 
                  [class.active]="orderForm.get('orderStatus')?.value === 'TERMINADO'" (click)="cambiarEstatusRampa('TERMINADO')">
            <span>🏁 4. Calidad Concluida / OK</span>
            <span class="badge bg-success text-white font-monospace" style="font-size: 0.65rem;">TERMINADO</span>
          </button>
          
        </div>
      </div>

    </div>

    <!-- Pie del Diálogo con Botones en Fila Elástica Móvil -->
    <div class="d-flex flex-wrap gap-2 justify-content-end border-top pt-3 mt-4">
      <button type="button" class="btn btn-sm btn-outline-secondary px-4 flex-grow-1 flex-md-grow-0 py-2 py-md-1" (click)="cerrarModal()" style="border-radius: 6px;">
        Cancelar
      </button>
      <button type="submit" class="btn btn-sm btn-primary px-5 fw-bold shadow-sm flex-grow-1 flex-md-grow-0 py-2 py-md-1" [disabled]="guardando" style="border-radius: 6px;">
        <span *ngIf="guardando" class="spinner-border spinner-border-sm me-2"></span>
        💾 Sellar Orden de Servicio
      </button>
    </div>
  </form>

</div>